import React from 'react'
import Icon from '../index'

const CloseIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <path
      d="M7,9 L1.00292933,9 C0.449026756,9 -8.8817842e-16,8.55613518 -8.8817842e-16,8 L-8.8817842e-16,8 C-8.8817842e-16,7.44771525 0.437881351,7 1.00292933,7 L7,7 L7,1.00292933 C7,0.449026756 7.44386482,0 8,0 L8,0 C8.55228475,0 9,0.437881351 9,1.00292933 L9,7 L14.9970707,7 C15.5509732,7 16,7.44386482 16,8 L16,8 C16,8.55228475 15.5621186,9 14.9970707,9 L9,9 L9,14.9970707 C9,15.5509732 8.55613518,16 8,16 L8,16 C7.44771525,16 7,15.5621186 7,14.9970707 L7,9 Z"
      transform="translate(8.000000, 8.000000) rotate(-315.000000) translate(-8.000000, -8.000000)"
    />
  </Icon>
)

CloseIcon.propTypes = {
  ...Icon.propTypes,
}

export default CloseIcon
